if (window.VariationsWidget == null) {
  window.VariationsWidget = {};
}

if (VariationsWidget.Views == null) {
  VariationsWidget.Views = {};
}

VariationsWidget.Views.Option = require('./option');

VariationsWidget.Views.OptionCollection = Backbone.View.extend({
  events: {
    "change": "selectionChanged"
  },
  initialize: function() {
    var optionElementModel;
    _.bindAll(this, 'selectionChanged', 'render');
    return this.optionElementViews = (function() {
      var i, len, ref, results;
      ref = this.collection.models;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        optionElementModel = ref[i];
        results.push(new VariationsWidget.Views.Option({
          el: "#trait-" + optionElementModel.get('traitIndex') + "-" + optionElementModel.get('id'),
          model: optionElementModel
        }));
      }
      return results;
    }).call(this);
  },
  render: function() {
    var i, len, optionElementView, ref, results;
    ref = this.optionElementViews;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      optionElementView = ref[i];
      results.push(optionElementView.render());
    }
    return results;
  },
  isSelectedOptionDisabled: function(selectElement) {
    return selectElement != null ? selectElement.options[selectElement.selectedIndex].disabled : void 0;
  },
  selectionChanged: function(e) {
    var $currentElement, model, value;
    $currentElement = $(e.currentTarget)[0];
    if (VariationsWidget.controller.ie7 && this.isSelectedOptionDisabled($currentElement)) {
      $currentElement.selectedIndex = 0;
    }
    value = $(e.currentTarget).val();
    model = this.collection.chosen(value);
    return VariationsWidget.controller.render({
      trait: this.collection.models[0].get('traitName'),
      selection: value,
      id: model.get('id')
    });
  }
});

VariationsWidget.Views.OptionCollection.create = function(collections) {
  var i, index, len, results, trait;
  results = [];
  for (index = i = 0, len = collections.length; i < len; index = ++i) {
    trait = collections[index];
    results.push(new VariationsWidget.Views.OptionCollection({
      collection: trait,
      el: "#trait-" + index
    }));
  }
  return results;
};

module.exports = VariationsWidget.Views.OptionCollection;

//# sourceMappingURL=data:application/json;base64,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
